import React, { Component } from 'react'
import BookingInput from '../Booking/bookinginput';
import formhoc from './formhoc';
import { contact_api } from '../../actions/http';
import ButtonLoader from '../btnloader';

class ContactForm extends Component {
    render() {
        const {ipState, onChange, formFilled} = this.props;
        const { name, name_err, phone_number, phone_number_err, form_fetching, message, message_err } = ipState;
        return (
            <form>
                <h3 className="f-600 m-b-20 m-t-20">Send us a Message</h3>
                <div className="row">
                <BookingInput 
                        size={12} 
                        type="text"
                        name="name"
                        onChange={onChange}
                        placeholder="Name" 
                        value={name}
                        err={name_err}
                    />
                    <BookingInput 
                        size={12} 
                        type="number"
                        name="phone_number"
                        placeholder="Phone Number" 
                        maxLength={10}
                        onChange={onChange}
                        value={phone_number}
                        err={phone_number_err}
                    />
                    <div className="col-md-12">
                        <textarea name="message"  onChange={onChange} value={message} className={"form-control input-md" + (message_err ? " iperr" : "")} placeholder="Message" />
                        {message_err && <div className="errtxt">{message_err}</div>}
                    </div>
                    <div className="col-md-12">
                        <button disabled={formFilled && !form_fetching ? false : true} type="submit" className="btn m-t-10 btn-block btn-ouja">{ form_fetching ? <ButtonLoader /> : 'Submit' }</button>
                    </div>
                </div>
            </form>
        )
    }
}


const inputs = [
    {
        name: "name"
    },
    {
        name: "phone_number",
        validate: {type: "PHONE_NUMBER"}
    },
    {
        name: "message"
    },
    {
        name: "type",
        defaultValue: 1
    }
]

const formConfig = {
    url: contact_api,
    method: "POST" 
};

export default formhoc(ContactForm, inputs, formConfig);